import React from 'react';
import Image, { ImageProps } from 'components/commercetools-ui/atoms/image';
import useImageSizes from 'helpers/hooks/useImageSizes';
import { Reference } from 'types/reference';
import Link from '../../atoms/link';

export interface Props {
  tile: {
    title: string;
    image: ImageProps;
    target?: Reference;
  };
}

const Tile: React.FC<Props> = ({ tile }) => {
  const tileImageSizes = useImageSizes({ md: 0.5, lg: 0.25, defaultSize: 0.25 });

  return (
    <Link link={tile.target} className="block shrink-0 grow basis-0">
      <div className="relative overflow-hidden rounded-2xl" style={{ paddingBottom: '130%' }}>
        <Image
          {...tile.image}
          sizes={tileImageSizes}
          alt={tile.title}
          fill
          style={{ objectFit: 'cover' }}
          className="object-cover"
        />
        <h2 className="pointer-events-none absolute inset-x-20 bottom-20 text-left text-20 font-bold leading-tight text-white md:text-24">
          {tile.title}
        </h2>
      </div>
    </Link>
  );
};

export default Tile;
